import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import routes from "./routes";
import withTracker from "./withTracker";

import "bootstrap/dist/css/bootstrap.min.css";
import "./shards-dashboard/styles/shards-dashboards.1.1.0.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./config/commonStyles.css";
import Errors from "./views/Errors";
import { strings } from "./localization";
import { getPrimaryColor, getSecondaryColor } from "./config";
import { getFCMToken } from "./utils/firebaseUtils";
import OrderCompleteDialog from "./components/OrderCompleteDialog";
import { Store, Dispatcher } from "./flux";
import Constants from "./flux/constants";
import { ToastContainer } from "react-toastify";

const testOrderData = {
  orderId: "ORD-12345",
  restaurantName: "Starbucks Coffee",
  completionTime: "2:30 PM",
  totalAmount: "24.50",
  orderItems: [
    { name: "Cappuccino", quantity: 2 },
    { name: "Chocolate Croissant", quantity: 1 },
    { name: "Blueberry Muffin", quantity: 1 },
    { name: "Iced Coffee", quantity: 1 },
  ],
};

export default function App() {
  const primaryColor = getPrimaryColor();
  const secondaryColor = getSecondaryColor();
  document.documentElement.style.setProperty("--primary-color", primaryColor);
  document.documentElement.style.setProperty(
    "--secondary-color",
    secondaryColor
  );

  const [showOrderCompleteDialog, setShowOrderCompleteDialog] = useState(false);
  const [orderCompleteData, setOrderCompleteData] = useState(null);

  const requestPermission = async () => {
    console.log('APP JS CALLED!')
    //requesting permission using Notification API
    const permission = await Notification.requestPermission();
    console.log("permission", permission);
    if (permission === "granted") {
      const token = await getFCMToken();
      console.log("Token generated : ", token);
    } else if (permission === "denied") {
      //notifications are blocked
      console.log("notification permission denied");
      // alert("You denied for the notification");
    }
  };

  // Listen for order complete notifications
  useEffect(() => {
    const handleOrderComplete = (orderData) => {
      console.log("Order complete notification received:", orderData);
      setOrderCompleteData(orderData);
      setShowOrderCompleteDialog(true);
    };

    // Register listener for order complete dialog
    Store.on(Constants.SHOW_ORDER_COMPLETE_DIALOG, handleOrderComplete);

    // Cleanup listener on unmount
    return () => {
      Store.removeListener(
        Constants.SHOW_ORDER_COMPLETE_DIALOG,
        handleOrderComplete
      );
    };
  }, []);

  // TOOD: NOTIFICATION CODE
  useEffect(() => {
    requestPermission();
  }, []);

  return (
    <Router>
      <div>
        <Switch>
          {routes.map((route, index) => {
            return (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                component={withTracker((props) => {
                  return (
                    <route.layout {...props}>
                      <route.component {...props} />
                    </route.layout>
                  );
                })}
              />
            );
          })}
          {/* Catch-all 404 Route */}
          <Route
            path="/restaurants/*"
            component={() => {
              return (
                <Errors
                  exact={true}
                  number="404"
                  message={strings.page_not_found_title}
                  text={strings.page_not_found_msg}
                />
              );
            }}
          />
        </Switch>

        {/* OrderCompleteDialog - Shows only when notification received and tab is active */}
        {orderCompleteData && (
          <OrderCompleteDialog
            showModal={showOrderCompleteDialog}
            setShowModal={setShowOrderCompleteDialog}
            orderData={orderCompleteData}
          />
        )}

        {/* ToastContainer for displaying notifications */}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </Router>
  );
}
